import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { darkerBlue } from '@css/constants'

export const TabWrapper = styled('div')(css``)

export const IconWrapper = styled('span')(css`
  margin-left: 6px;

  & > svg {
    transform: rotate(-90deg);
    height: 12px;
    width: 12px;
  }
`)

export const getBtnStyles = (isActive: boolean) => css`
  border-radius: 0;
  box-shadow: none;
  padding: 22px 17px;
  position: relative;

  &:after {
    content: "";
    display: ${isActive ? "inline-block" : "none"};
    position: absolute;
    bottom: -14px;
    left: calc(50% - 10px);
    width: 0;
    height: 0;
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-top: 15px solid #173A68;
    z-index: 101;

    &:hover {
      background: ${darkerBlue};
    }
  }
`
